// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.matrix-grid {
  position: relative;
  display: inline-block;
  padding: 20px;
  white-space: pre-line;
}
.matrix-grid .matrix-grid-heading {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}
.matrix-grid .matrix-grid-content {
  position: relative;
}
.matrix-grid .matrix-grid-content .matrix-grid-content-grid {
  display: grid;
  gap: 0px;
  position: relative;
}
.matrix-grid .matrix-grid-content .matrix-grid-content-grid .matrix-grid-content-grid-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid gray;
  cursor: pointer;
}
.matrix-grid .matrix-grid-content .matrix-grid-content-svg {
  position: absolute;
  top: 0;
  left: 0;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/MatrixGrid.less"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;AACJ;AALA;EAOQ,eAAA;EACA,iBAAA;EACA,kBAAA;AACR;AAVA;EAaQ,kBAAA;AAAR;AAbA;EAeY,aAAA;EACA,QAAA;EACA,kBAAA;AACZ;AAlBA;EAmBgB,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,eAAA;AAEhB;AAzBA;EA4BY,kBAAA;EACA,MAAA;EACA,OAAA;EACA,oBAAA;AAAZ","sourcesContent":[".matrix-grid{\n    position: relative;\n    display: inline-block;\n    padding: 20px;\n    white-space: pre-line; // preserve \\n as line breaks\n\n    .matrix-grid-heading {\n        font-size: 24px;\n        font-weight: bold;\n        text-align: center;\n    }\n    \n    .matrix-grid-content{\n        position: relative;\n        .matrix-grid-content-grid {\n            display: grid;\n            gap: 0px;\n            position: relative;\n            .matrix-grid-content-grid-cell {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                border: 1px solid gray;\n                cursor: pointer;\n            }\n        }\n\n        .matrix-grid-content-svg {\n            position: absolute;\n            top: 0;\n            left: 0;\n            pointer-events: none;\n        }\n          \n          \n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
